import BaseService from './base'
import axios from '@/plugins/axios'

export default class CertifyTransferInstructionsService extends BaseService {
  static resource() {
    return 'api/v1/external/certifyTransferInstructions'
  }

  static async certify(accountCode, payload = {}) {
    const { data } = await axios.post(
      `${this.baseURL()}/${this.resource()}/${accountCode}`,
      payload
    )
    return data
  }
}
